var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rt-list-wrapper"},[_c('p',{staticClass:"rt-list-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"rt-list-slot"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }